/**
 * The new owner's note (owner spec 2026-10-09; routes/ownership.ts): "<Name> wants to make you the owner of <business>", with
 * Accept and Not now, at the top of every screen until answered. Never a wall: the shift goes on underneath.
 */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, ErrorBox, Notice } from "./ui.tsx";
import { useApi, useSession } from "../session.tsx";

export function OwnershipOfferBanner() {
  const s = useSession();
  const offer = s.me.ownershipOffers?.[0];
  const nav = useNavigate();
  if (!offer) return null;
  return (
    <div role="status" data-testid="ownership-offer">
      <Notice tone="info" title={`${offer.from.name} wants to make you the owner of ${offer.orgName}.`} action={<Button small onClick={() => nav(`/ownership/accept?org=${encodeURIComponent(offer.orgId)}`)}>See the offer</Button>}>
        <p>{offer.card === "keep" ? "Their card stays on file." : "Their card is removed when you accept; you add your own."}</p>
      </Notice>
    </div>
  );
}

/** Accept or Not now, for the offer of `orgId`. */
export function OfferButtons({ orgId, onDone }: { orgId: string; onDone(accepted: boolean, note: string | null): void }) {
  const api = useApi();
  const [busy, setBusy] = useState<"accept" | "decline" | null>(null);
  const [err, setErr] = useState<string>();
  async function go(kind: "accept" | "decline") {
    setBusy(kind); setErr(undefined);
    try {
      if (kind === "accept") { const r = await api.acceptTransfer(orgId); onDone(true, r.cardNote); }
      else { await api.declineTransfer(orgId); onDone(false, null); }
    } catch (x) { setErr(x instanceof Error ? x.message : String(x)); } finally { setBusy(null); }
  }
  return (
    <>
      <ErrorBox error={err} />
      <div className="row">
        <Button busy={busy === "accept"} onClick={() => void go("accept")}>Accept ownership</Button>
        <Button variant="secondary" busy={busy === "decline"} onClick={() => void go("decline")}>Say no to the offer</Button>
      </div>
    </>
  );
}
